// extracted by mini-css-extract-plugin
export default {"header":"styles_header__CPIIk","logo":"styles_logo__KS78l","greetings":"styles_greetings__MZ6Hd"};